export default __webpack_public_path__ + "static/media/32.bf19d59a.jpg";